export default __webpack_public_path__ + "static/media/arrow_up.c71e4752.svg";